// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Kpyuf","buttons":"_3cUIb"};